import { Route, Routes } from 'react-router-dom';

import { ExperimentsContextValue, ExperimentsProvider } from '../provider/provider';
import { Experiment_HolidayPromotion } from './holidayPromotion/HolidayPromotionPage';
import { Experiment_EmailConfirmation } from './onboardingExtension';

const Experiment_Routes = ({ useOpenGlobalOnboarding }: ExperimentsContextValue) => {
  return (
    <ExperimentsProvider value={{ useOpenGlobalOnboarding }}>
      <Routes>
        <Route path="/onboarding-extension" element={<Experiment_EmailConfirmation />} />
        <Route path="/gift" element={<Experiment_HolidayPromotion />} />
      </Routes>
    </ExperimentsProvider>
  );
};

export { Experiment_Routes };
